import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { Box, Typography, useTheme } from '@mui/material'
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

type Props = {
  title?: string
  description?: string
}

export const NotFound = ({ title, description }: Props) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const resolvedTitle = title || t('Страница не найдена')
  const resolvedDescription = description || t('Запрашиваемая страница не существует.')
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        minHeight: '100vh',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
          width: '72px',
          height: '72px',
          borderRadius: '50%',
          backgroundColor: theme.palette.secondary.main,
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: '40px' }} />
      </Box>
      <Typography sx={{ fontSize: '24px', fontWeight: 600 }} variant="h1">
        {resolvedTitle}
      </Typography>
      <Typography color="text.secondary" variant="body1">
        {resolvedDescription}
      </Typography>
      <Link to="/">{t('Вернуться на главную')}</Link>
    </Box>
  )
}
